// extracted by mini-css-extract-plugin
module.exports = {"banner":"EmergencyBanner_banner__ZYaf4","exclamation-svg":"EmergencyBanner_exclamation-svg__2SRJE"};